

module.exports = (from, to, percent) => ~~((to - from) * percent) + from;



// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/internal/blendPartial.js